import { normalizeMatchLayout } from 'modules/manager/domain/match-layout';
import { DEFAULT_TEMPLATE_TYPE, TemplateType, isKnownTemplateType } from 'modules/manager/domain/template-type';
import { MediaManagerTemplateDto } from '../interfaces/supabase/media-manager/dto';
import { MediaManagerTemplate } from '../interfaces/supabase/media-manager/entity';

const mediaManagerTemplateDataMapper = (template: MediaManagerTemplateDto): MediaManagerTemplate => {
  const {
    created_at,
    updated_at,
    tournament_id,
    sport_type,
    template_type,
    template_subtypes,
    match_layout,
    ...rest
  } = template;

  return {
    ...rest,
    createdAt: created_at,
    updatedAt: updated_at,
    tournamentId: tournament_id,
    sportType: sport_type,
    templateType: coerceTemplateType(template_type),
    templateSubtypes: Array.isArray(template_subtypes) ? template_subtypes : [],
    matchLayout: normalizeMatchLayout(match_layout),
  };
};

function coerceTemplateType(value: unknown): TemplateType {
  if (isKnownTemplateType(value as string | undefined | null)) {
    return value as TemplateType;
  }
  // Why: a row stamped by a newer client (or a value typed in directly via SQL)
  // must not crash the editor. Fall back to the default and warn so the drift
  // is visible in dev tools.
  if (value !== undefined && value !== null && value !== '') {
    // eslint-disable-next-line no-console
    console.warn(`[media-manager] unknown template_type "${value}" — falling back to "${DEFAULT_TEMPLATE_TYPE}"`);
  }
  return DEFAULT_TEMPLATE_TYPE;
}

export default mediaManagerTemplateDataMapper;
